import { FormService } from "./form.service";

/***
 * This is the standard backend implementation that uses the API server to get data.
 */
export class FormServiceImpl implements FormService {
    appAPIUrl: string;

    constructor(appAPIUrl: string, _showSnackbar: (message: string, severity: string) => void) {
        this.appAPIUrl = appAPIUrl;
    }
    public submitForm = async (
        site: string,
        name: string,
        data: { [key: string]: string | boolean },
    ): Promise<{ success: boolean, message: string | null }> => {
        const result = await fetch(`${this.appAPIUrl}/submit/${site}/${name}`, {
            method: "POST",
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        const fallbackMessage = result.statusText || "Could not submit form.";
        const contentType = result.headers.get("content-type");
        if (!contentType?.includes("application/json")) {
            return {
                success: result.ok,
                message: result.ok ? null : fallbackMessage,
            };
        }
        try {
            const json = await result.json();
            if (typeof json?.success === "boolean") {
                return {
                    success: json.success,
                    message: json.message || null,
                };
            }
        } catch (_error) {
            return { success: false, message: fallbackMessage };
        }

        return {
            success: result.ok,
            message: result.ok ? null : fallbackMessage,
        };
    }
}
